import isEmpty from 'lodash/isEmpty';



const getConfigurations = (configName) => !isEmpty(localStorage.getItem('configs')) ?
  JSON.parse(localStorage.getItem('configs'))?.[configName] : {};


export default getConfigurations;
